type ActivityLog = {
  action_type: string;
  resource_type: string;
  resource_id?: string;
  details?: any;
  phi_accessed?: boolean;
};

export const logActivity = async ({
  action_type,
  resource_type,
  resource_id,
  details,
  phi_accessed,
}: ActivityLog) => {
  // For now, just log to console in development
  console.log('Activity logged:', {
    action_type,
    resource_type,
    resource_id,
    details,
    phi_accessed,
    timestamp: new Date().toISOString(),
    user_agent: navigator.userAgent,
  });
};